import { ref } from 'vue';

// Module-scope state for Test Drive. Because these refs live at module scope (not
// inside the component), they survive the component being unmounted/remounted when
// you navigate away and back — so the live chat and Chanel thread aren't lost.
// A full browser refresh still resets them, which matches the "fresh session" idea.

export const newSessionId = () =>
  `motion-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;

export const msgs = ref([]);          // live bot chat transcript
export const input = ref('');
export const last = ref(null);        // last retrieval payload (details panel)
export const session = ref(newSessionId());

export const reviewTurn = ref(null);  // turn under review by Chanel
export const chanelMsgs = ref([]);    // operator ↔ Chanel chat
export const chanelInput = ref('');
export const proposal = ref(null);    // previewed change before apply
export const chanelThreadId = ref(null);

// Reset everything to a clean slate (used by Clear and after a successful apply).
export function resetMotion() {
  msgs.value = [];
  last.value = null;
  reviewTurn.value = null;
  chanelMsgs.value = [];
  proposal.value = null;
  chanelThreadId.value = null;
  session.value = newSessionId();
}
